import jQuery from 'jquery';

var cardContVariation;

// Chaves de homologação
var cardUrlApi = wcParams.wcRestUrl;
var cardApiKey = wcParams.wcApiKey;
/**
 * Destino
 * Muda formulário de acordo com destino escolhido
*/
jQuery("#selectDestinyProductCard").on('change', function() {

    let options = '';

    jQuery("#selectDestinyProductCard option[value='']").each(function() {
        jQuery(this).remove();
    });

    jQuery('.card-mobile-none').removeClass('card-mobile-none');

    options = '<option value="chip">Ver planos com Chip</option><option value="esim">Ver planos com eSIM</option>';

    jQuery("#selectPlanTypeChip").html('<option value="">Selecione uma opção</option>').append(options);

    jQuery("#selectPlanTypeChip").val("").removeAttr("disabled");
    jQuery("#selectPlanProductCard").val("").prop('disabled',true);
    jQuery('[name="custom_activate_date"]').val("").prop('disabled',true);
    jQuery("#btnCardProduct").prop('disabled',true);
    jQuery("#divOptions").html('');
});

/**
 * Tecnologia
 * Busca produtos de acordo com o tipo de chip e destino.
 */
jQuery("#selectPlanTypeChip").on('change', function() {
    let destiny  = jQuery("#selectDestinyProductCard").val();
    let type     = jQuery(this).val();
    let category = '';

    jQuery("#selectPlanTypeChip option[value='']").each(function() {
        jQuery(this).remove();
    });

    jQuery("#selectPlanProductCard").html('<option value="">Carregando...</option>');
    jQuery("#divOptions").html('');

    switch(destiny) {
        case 'USA' :
            if(type == 'chip') category = wcParams.estados_unidos_mexico_e_canada_chip;
            else category = wcParams.estados_unidos_mexico_e_canada_e_sim;
            break;
        case 'UE' :
            if(type == 'chip') category = wcParams.europa_chip;
            else category = wcParams.europa_e_sim;
            break;
        case 'AS' :
            if(type == 'chip') category = wcParams.america_do_sul_central_e_caribe_chip;
            else category = wcParams.america_do_sul_central_e_caribe_e_sim;
            break;
        case 'MUNDI' :
            if(type == 'chip') category = wcParams.mundi_chip;
            else category = wcParams.mundi_e_sim;
            break;
        default :
            category = '';
    }

    var restUrl = `${cardUrlApi}products?${cardApiKey}&category=${category}&status=publish`;
    var jqxhr = jQuery.getJSON(restUrl, function(data) {
        var options;
        if( data.length !== 0 ) {
            jQuery.each(data, function(key, val) {
                options = options + "<option value='" + val.id + "'>" + val.name + "</option>";
            });

            jQuery("#selectPlanProductCard").html('<option value="">Selecione o tipo de tecnologia</option>').append(options).removeAttr("disabled");
        } else {
            jQuery("#selectPlanProductCard").html('<option value="">Não há planos nessa categoria</option>');
        }
    });

});

/**
 * Plano
 * Busca variações do plano
 */
jQuery("#selectPlanProductCard").on('change', function() {

    jQuery("#selectPlanProductCard option[value='']").each(function() {
        jQuery(this).remove();
    });

    cardContVariation = 0;
    let productId = jQuery(this).val();
    let jqxhr = jQuery.getJSON(cardUrlApi + "products/"+productId+"/?" + cardApiKey, function(data) {
        if(data.attributes.length != 0){
            let html    = '';
            let imgSrc  = jQuery('#iconSelect').attr('src');
            let metaDataItems =  data.meta_data;

            jQuery.each(data.attributes, function(key, val) {
                if( val.variation ) {
                    let customNameAttribute = metaDataItems.find(item => item.key === '_custom_name_' + val.position);
                    let customNameAttributeValue = ( customNameAttribute && customNameAttribute.value.trim() ) ? customNameAttribute.value : val.name;

                    html = html + '<div class="blog-product__card-content--select">';
                    html = html + '<label class="select-title" id="option0">'+customNameAttributeValue+'</label>';
                    html = html + '<select name="atributes[' + key + ']" class="input-select" required>';
                    jQuery.each(val.options, function(k, o) {
                        html = html + "<option value='" + o + "'>" + o + "</option>";
                    });
                    html = html + '</select>';
                    html = html + '<span><img src="'+imgSrc+'"></span>';
                    html = html + '</div>';

                    cardContVariation++;
                }
            });

            jQuery("#divOptions").html(html);

        }
    });

    jQuery('[name="custom_activate_date"]').removeAttr("disabled");
    jQuery("#btnCardProduct").removeAttr("disabled");

});

/**
 * Enviar
 * Valida o formulário e envia os dados para o carrinho
 */
jQuery("#btnCardProduct").on('click', function() {
    let productId = jQuery("#selectPlanProductCard").val();
    let cardAtributes = [];
    var calendarioLength = jQuery('[name="custom_activate_date"]').val().length;
    jQuery(this).val('Carregando...').prop('disabled', true);

    if( calendarioLength != 10 ){
        alert( "Por favor, preencha uma data válida." );
        jQuery( this ).removeAttr( 'disabled' ).val( 'Faça sua cotação' );
        jQuery( '[name="custom_activate_date"]' ).focus();

        return;
    }

    // Busca variações escolhidas e insere em um array
    for(var i = 0; i < cardContVariation; i++) {
        cardAtributes.push(jQuery("[name='atributes["+i+"]']").val());
    }

    const perPage     = 100;
    let page          = 1;
    let allVariations = [];

    function fetchPage( page ) {
        return new Promise( ( resolve, reject ) => {
            jQuery.getJSON( `${cardUrlApi}products/${productId}/variations?${cardApiKey}&per_page=${perPage}&page=${page}&order=asc`, function(data) {
                if ( data.length > 0 ) {
                    resolve( data );
                } else {
                    resolve( [] );
                }
            }).fail( function( jqxhr, textStatus, error ) {
                reject( error );
            });
        });
    }

    function getTotalPages() {
        return new Promise( ( resolve, reject ) => {
            jQuery.getJSON( `${cardUrlApi}products/${productId}/variations?${cardApiKey}&per_page=1&order=asc`, function( data, status, xhr ) {
                const totalVariations = parseInt( xhr.getResponseHeader( 'X-WP-Total' ) );
                const totalPages      = Math.ceil( totalVariations / perPage );
                resolve( totalPages );
            }).fail( function( jqxhr, textStatus, error ) {
                reject( error );
            });
        });
    }

    getTotalPages().then( totalPages => {
        let promises = [];

        for ( let page = 1; page <= totalPages; page++ ) {
            promises.push( fetchPage( page ) );
        }

        Promise.all( promises ).then( results => {
            results.forEach( pageData => {
                allVariations = allVariations.concat( pageData );
            });

            jQuery.each( allVariations, function( key, val ) {
                let attributes = [];

                jQuery.each( val.attributes, function( k, v ) {
                    attributes.push( v.option );
                });

                var isEqual = JSON.stringify( cardAtributes ) === JSON.stringify( attributes );

                if ( isEqual ) {
                    jQuery( "#cardVariationId" ).val( val.id );
                    return false;
                }
            });

            jQuery( "#formProductCard" ).submit();

        }).catch( error => {
            console.error( 'Erro ao buscar variações:', error );
        });
    }).catch( error => {
        console.error( 'Erro ao obter total de páginas:', error );
    });
});

jQuery('.btn-close').on('click', function(){
    jQuery('.blog-product-single').css('display', 'none');
});
